import { getOutbox, getPlayer, removeFromOutbox, setPlayer } from '@/game/storage'
import { httpStatus, postResult } from './client'

let inFlight: Promise<void> | null = null

/**
 * Досылает очередь партий на сервер. Одновременно идёт одна досылка: game over
 * и событие online могут совпасть, а двойная отправка — лишние запросы (дублей
 * в базе не будет и так — сервер идемпотентен по client_id).
 */
export function flushOutbox(): Promise<void> {
  inFlight ??= run().finally(() => {
    inFlight = null
  })
  return inFlight
}

async function run(): Promise<void> {
  const player = getPlayer()
  // Без ника партии копятся: как только игрок его заведёт, всё уйдёт разом.
  if (!player) return

  for (const record of getOutbox()) {
    try {
      await postResult(player.token, record)
    } catch (error) {
      const status = httpStatus(error)
      if (status === 401) {
        // Токен больше не действует (игрока удалили в админке) — нужен новый
        // ник. Партии остаются в очереди и уйдут от нового игрока.
        setPlayer(null)
        return
      }
      // 422 — сервер счёл партию неправдоподобной; повтор ничего не изменит,
      // а застрявшая запись держала бы очередь вечно.
      if (status !== 422) return
    }
    removeFromOutbox(record.id)
  }
}
